import Admin from 'components/admin/Admin.vue'

import App from 'components/App.vue'
import ComingSoon from 'components/ComingSoon.vue'

import Sample from 'components/common/Sample.vue'
import Home from 'components/home/Home.vue'

import Login from 'components/Login.vue'
import RetrievePassword from 'components/RetrievePassword.vue'
import assign from 'lodash/assign'

import { admin_dashboard, admin_map, admin_routes } from './admin'
import { dashboard, home_map, home_routes } from './home'

export * from './admin'
export * from './home'

export let login = {
  path: '/login',
  // auth === false 时，不需要检查是否登录
  meta: {auth: false},
  component: Login,
}
export let retrieve_password = {
  path: '/retrieve/password',
  meta: {auth: false},
  component: RetrievePassword,
}
export let sample = {
  path: '/sample',
  meta: {auth: false},
  component: Sample,
}
export let coming_soon = {
  path: 'coming/soon',
  component: ComingSoon,
}
export let admin_coming_soon = {
  path: 'coming/soon',
  component: ComingSoon,
}

export let routes = [
  login,
  retrieve_password,
  sample,
  {
    path: '',
    component: App,
    children: [
      {
        path: '/admin',
        component: Admin,
        children: [
          {
            path: '',
            redirect: admin_dashboard,
          },
          admin_coming_soon,
          ...admin_routes,
          {
            path: '*',
            redirect: admin_dashboard,
          },
        ],
      },
      {
        path: '/home',
        component: Home,
        children: [
          {
            path: '',
            redirect: dashboard,
          },
          coming_soon,
          ...home_routes,
          {
            path: '*',
            redirect: dashboard,
          },
        ],
      },
    ],
  },
]

export let route_map = assign({
  login,
  retrieve_password,
  sample,
  coming_soon,
  admin_coming_soon,
}, admin_map, home_map)



// WEBPACK FOOTER //
// ./src/router/routes/index.js